<!-- <div id="wrapper" (scroll)="onScrollEvent($event)" [ngClass]="{'header-top': isListingPages()}"> -->

<!--Header Frontend Panel -->
<app-header></app-header>

<!-- Main Container -->
<router-outlet></router-outlet>

<!-- </div> -->
